export default __webpack_public_path__ + "static/media/a028-1.d5b597bd.png";